import script from "./GradeEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradeEditor.vue?vue&type=script&setup=true&lang=ts"

import "./GradeEditor.vue?vue&type=style&index=0&id=080d2c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080d2c0a"]])

export default __exports__